export const screenGroups = {
  B2C: "b2c",
  B2B: "b2b",
  RESERVATION: "reservation",
  SIGN_UP: "sign-up",
  LOGIN: "login",
  PROFILE: "profile"
};
